const NewBusinessBasicsReducer = (state = 0, action) => {
  switch (action.type) {
    case "BUSINESS_BASIC_DONE":
      return state + 1;
    case "BUSINESS_BASIC_FAILED":
      return state;
    default:
      return state;
  }
};
const NewBusinessContentInfoReducer = (state = 0, action) => {
  switch (action.type) {
    case "BUSINESS_CONTENT_DONE":
      return state + 1;
    case "BUSINESS_CONTENT_FAILED":
      return state;
    default:
      return state;
  }
};
const NewBusinessSocialMediaReducer = (state = 0, action) => {
  switch (action.type) {
    case "BUSINESS_SOCIAL_DONE":
      return state + 1;
    case "BUSINESS_SOCIAL_FAILED":
      return state;
    default:
      return state;
  }
};
const NewBusinessStatsReducer = (state = 0, action) => {
  switch (action.type) {
    case "BUSINESS_STATS_DONE":
      return state + 1;
    case "BUSINESS_STATS_FAILED":
      return state;
    default:
      return state;
  }
};

const NewBusinessThemeReducer = (state = 0, action) => {
  switch (action.type) {
    case "BUSINESS_THEME_DONE":
      return state + 1;
    case "BUSINESS_THEME_FAILED":
      return state;
    default:
      return state;
  }
};

export {
  NewBusinessBasicsReducer,
  NewBusinessContentInfoReducer,
  NewBusinessSocialMediaReducer,
  NewBusinessStatsReducer,
  NewBusinessThemeReducer
};
